import React, { useEffect, useState } from "react";
import axiosInstance from "../../../ReusableComponents/Axios";
import { useSelector } from "react-redux";
import { exportToExcel } from "../../../Student/Reusablecomponents/RegularFunctions";

const QuestionAnalysis = (props) => {

    const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);

    const [filter, setFilter] = useState("All");

    const filteredStudents = props.SData?.filter((student) => {
        if (filter === "1") return student.answerStatus;
        if (filter === "0") return !student.answerStatus;
        return true;
    });

    const DownloadFile = () => {
        // const Data = PAFilter ? filteredStudents.filter((item) => item.status === PAFilter) : filteredStudents
    //     const XL = filteredStudents?.map((item, index) => {
    //         const row = {
    //             SNo: index + 1,
    //             "Student ID": item.studentId,
    //             "Student Name": item.studentName,
    //             "Grade": item.grade,
    //      {
    //             filteredStudents?.[0]?.questionId ? filteredStudents?.[0]?.questionId
    //             : Object.keys(filteredStudents?.[0]).filter((key) => key.startsWith("q")).map((QT) => (
    //                 QT.toUpperCase()
    //             ))
    //         }: {
    //             filteredStudents?.[0]?.questionId ?

    //             item.answerStatus ? "✓" : "✕"

    //             : Object.keys(filteredStudents?.[0]).filter((key) => key.startsWith("q")).map((QT) => (
    //                 item[QT] === "Correct" ? "✓" : "✕"
    //             ))
    //         }
    //     };
    //     return row;
    // })

const XL = filteredStudents?.map((item, index) => {
    const row = {
        SNo: index + 1,
        "Student ID": item.studentId,
        "Student Name": item.studentName,
        Grade: item.grade,
    };

    if (filteredStudents?.[0]?.questionId) {
        row[`Q - ${filteredStudents[0].questionId}`] = item.answerStatus ? "✓" : "✕";
    } else {
        Object.keys(filteredStudents?.[0] || {})
            .filter((key) => key.startsWith("q"))
            .forEach((QT) => {
                row[QT.toUpperCase()] =
                    item[QT] === "Correct" ? "✓" : "✕";
            });
    }

    return row;
});

console.log("XL",XL)


        exportToExcel(
            XL,
            `Need to add file name`,
            false,
            "Student Wise Result",
      );
};

return (
    <div className="question-analysis mt-3">

        {/* Header */}

        <div className="qa-header">

            <div>
                {filteredStudents?.[0]?.questionId ?
                    <h1>Question - {filteredStudents?.[0]?.questionId} Analysis</h1>
                    :
                    <h1>LO Analysis: {filteredStudents?.[0]?.lOName}</h1>

                }

                {filteredStudents?.[0]?.questionId ? <h3> Learning Objective: <span> Not mapped.</span> </h3>
                    : <h3> Displaying question-level breakdown for this objective. </h3>}

                <p> Detailed student performance for this selection</p>

            </div>

            <div className="qa-actions">

                <button className="export-btn" onClick={() => DownloadFile()}> 📥 Export Excel </button>

                <div className="filter-group">

                    <label>Result Filter:</label>

                    <select
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    >
                        <option value="All">Show All</option>
                        <option value="1">Correct / Proficient</option>
                        <option value="0">Incorrect / Needs Focus</option>
                    </select>

                </div>

                <button className="closebtn" onClick={() => props.SetSData("")}>
                    ✕ Close List
                </button>

            </div>

        </div>

        {/* Table */}

        <div className="qa-table-container">

            <table className="qa-table">

                <thead>

                    <tr>
                        <th>Student ID</th>
                        <th>Name</th>
                        <th>Grade</th>
                        {filteredStudents?.[0]?.questionId ? <th>{filteredStudents?.[0]?.questionId}</th>
                            : Object.keys(filteredStudents?.[0]).filter((key) => key.startsWith("q")).map((QT) => (
                                <th>{QT.toUpperCase()}</th>
                            ))}
                    </tr>

                </thead>

                <tbody>

                    {filteredStudents?.map((student) => (

                        <tr key={student.studentId}>

                            <td className="student-id">
                                {student.studentId}
                            </td>

                            <td className="student-name">
                                {student.studentName}
                            </td>

                            <td>{student.grade}</td>


                            {filteredStudents?.[0]?.questionId ? <td className="result-cell">

                                {student.answerStatus ? (
                                    <span className="correct">✓</span>
                                ) : (
                                    <span className="wrong">✕</span>
                                )}

                            </td>
                                : Object.keys(filteredStudents?.[0]).filter((key) => key.startsWith("q")).map((QT) => (
                                    <td>{student[QT] === "Correct" ?
                                        <span className="correct">✓</span> : <span className="wrong">✕</span>
                                    }</td>
                                ))}


                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    </div>
);
}
export default QuestionAnalysis;